import src from "IMAGE";
export default { src, width: 1920, height: 147, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAIElEQVR42mMo8/j/v8zz///i4L//8+N/gTGIDRIDyQEAYjYWBQavtH0AAAAASUVORK5CYII="};
